import { useState } from 'react';
import _get from 'lodash/get';
import type { Dictionary } from 'lodash';

import { ServiceProvider } from 'models';

import { PageTitle } from 'containers';
import { ProviderCollapseBlock, PageLoader, ProviderInfo } from 'components';
import { useStyles } from './style';

interface Props {
  serviceProvidersGroups: {
    Name: string | null;
    Order: number | null;
    ServiceProviders: Dictionary<ServiceProvider[]>;
  }[];
  loading: boolean;
  error: boolean;
}

const ServiceProvidersDetails: React.FC<Props> = ({
  serviceProvidersGroups,
  loading,
  error,
}) => {
  const classes = useStyles();
  const [groupControlState, setGroupControlState] = useState(() => {
    if (!serviceProvidersGroups.length) {
      return {};
    }

    return serviceProvidersGroups.reduce((acc, next) => {
      if (next.Name) {
        acc[next.Name] = false;
        return acc;
      }

      return acc;
    }, {} as { [key: string]: boolean });
  });

  const handleChangeControlState = (id: string | null) => {
    if (!id) {
      return;
    }

    setGroupControlState((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  if (loading) {
    return <PageLoader />;
  }

  return (
    <>
      <PageTitle />
      <div className={classes.root}>
        {serviceProvidersGroups.map((group) => {
          const { Name, ServiceProviders } = group;

          return (
            <ProviderCollapseBlock
              key={Name}
              open={Name ? _get(groupControlState, Name) : false}
              title={Name}
              handleClick={handleChangeControlState}
            >
              {Object.keys(ServiceProviders).map((key) => {
                const serviceProviders = ServiceProviders[key];

                return (
                  <div className={classes.groupInfoWrapper} key={key}>
                    <h3 className={classes.groupInfoTitle}>{key}</h3>
                    <div className={classes.flex}>
                      {serviceProviders.map((provider) => {
                        return (
                          <ProviderInfo key={provider.Id} provider={provider} />
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </ProviderCollapseBlock>
          );
        })}
      </div>
    </>
  );
};

export default ServiceProvidersDetails;
